var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawer-toggle",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }